import User from "../entities/User";

export default class UserFactory {
  static create(userJson) {
    const user = new User();

    for (const [key, value] of Object.entries(userJson)) {
      user[key] = value;
    }

    user.fullName = [user.firstName, user.surname].join(" ");
    user.managerFullName = user.manager ? [user.manager.firstName, user.manager.surname].join(" ") : "";

    return user;
  }

  static createFromArray(users) {
    // Handle cases where users is not an array
    if (!Array.isArray(users)) {
      console.warn("UserFactory.createFromArray received non-array data:", users);
      return [];
    }
    return users.map((userJson) => UserFactory.create(userJson));
  }
}
